import { bool, func, number } from 'prop-types'
import { CalendarFilterButton } from '@opallabs/filters'
import { Conditional } from '@opallabs/kuiper'

/**
 * The week and day filters live in a Backbone tray that takes the button's
 * place while it is open, so this only draws the button when it is shut.
 */
const FilterButton = ({
  activeFiltersCount = 0,
  isFiltersTrayOpen,
  onToggleFilters,
}) => (
  <Conditional condition={!isFiltersTrayOpen}>
    <CalendarFilterButton
      count={activeFiltersCount}
      isOpen={Boolean(isFiltersTrayOpen)}
      onToggle={() => onToggleFilters(true)}
    />
  </Conditional>
)

FilterButton.propTypes = {
  activeFiltersCount: number,
  isFiltersTrayOpen: bool,
  onToggleFilters: func.isRequired,
}

export default FilterButton
